<template>
  <span
    class="pill"
    :class="{ start, end }"
  >
    <icon
      class="pill-icon"
      :name="iconName"
      :variant="variant"
    />
    <slot />
  </span>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'CountPill',
  components: {
    Icon,
  },
  props: {
    iconName: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
    start: {
      type: Boolean,
      default: false,
    },
    end: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    countLabel() {
      return this.count === 1 ? this.label : `${this.label}s`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pill {
  background: #EFF3F6;
  color: black;
  font-size: rem-calc(12);
  font-weight: 600;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem .5rem;
  width: 2.6rem;

  .pill-icon {
    height: 1rem;
    width: 1rem;
  }

  &.start {
    border-radius: 4px 0px 0px 4px;
    margin-right: 2px;
  }

  &.end {
    border-radius: 0px 4px 4px 0px;
  }
}
</style>
